import * as yup from "yup";

export const WorkforceUpdateSchema = yup.object().shape({
  firstName: yup.string().required("Required"),
  lastName: yup.string(),
  emailAddress: yup.string(),
  dateOfJoining: yup.date(),
  dateOfBirth: yup.date(),
  contactNumber: yup.string(),
  aadharNumber: yup.string(),
  panNumber: yup.string(),
  permanentAddress: yup.string(),
  emergencyContactName: yup.string(),
  emergencyContactNumber: yup.string(),
  emergencyContactRelation: yup.string(),
  uploadPhoto: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  uploadAadharFront: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  uploadAadharBack: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  salary: yup.string(),
  salaryFrequency: yup.string(),
  salaryFrequencyType: yup.string(),
});
